import { Component, OnDestroy, OnInit } from '@angular/core';
import { ExperimentalFeaturesService, UserService, WindowRef } from '@ca/core/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PERMISSION_HOWTO } from 'src/app/shared/constants/constants';
import { ContactUsComponent } from '../../../shared/components/contact-us/contact-us.component';

@Component({
    selector: 'ca-feedback-button',
    templateUrl: './feedback-button.component.html',
    styleUrls: ['./feedback-button.component.scss'],
})
export class FeedbackButtonComponent implements OnInit, OnDestroy {
    isScrolled: boolean = false;
    hasHowToPermission: boolean = false;
    isMEDProjectEnabled = this.experimentalFeaturesService.isMEDProjectActive;

    constructor(
        private modal: NgbModal,
        private windowRef: WindowRef,
        private experimentalFeaturesService: ExperimentalFeaturesService,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        const userPermissions$: Observable<string[] | null> = this.userService.permissions ? of(this.userService.permissions) : this.userService.permissions$;
        userPermissions$
            .pipe(
                tap(() => {
                    this.hasHowToPermission = this.userService.hasPermissions([PERMISSION_HOWTO]);
                }),
            )
            .subscribe();

        this.windowRef.nativeWindow.addEventListener('scroll', this.scroll.bind(this), true);
    }

    ngOnDestroy(): void {
        this.windowRef.nativeWindow.removeEventListener('scroll', this.scroll.bind(this), true);
    }

    get showTutorial(): boolean {
        return this.experimentalFeaturesService.areInlineManualActivated;
    }

    scroll({ target }: Event): void {
        setTimeout(() => {
            this.isScrolled = (target as Element).scrollTop > 200;
        }, 250);
    }

    onContactClick(): void {
        this.modal.open(ContactUsComponent, { size: 'lg' });
    }
}
